import React from "react";
import { getStoredValue, setStoredValue } from "../../utils/sessionStorage";

export const RELOAD_ATTEMPTED_AT_KEY = "chunkerror-reload-attempted-at";
export const REPEATED_ERROR_WINDOW_MS = 10000;

export const withinRepeatedErrorWindow = (currentDate) => {
  const initialAttemptDate = getStoredValue(RELOAD_ATTEMPTED_AT_KEY);
  return !(
    initialAttemptDate === null ||
    currentDate - initialAttemptDate > REPEATED_ERROR_WINDOW_MS
  );
};

const isChunkLoadError = (error) => error?.name === "ChunkLoadError";

class ChunkErrorBoundary extends React.Component {
  state = { chunkLoadFailed: false };

  static getDerivedStateFromError(error) {
    // Forward irrelevant and non-transient errors
    if (!isChunkLoadError(error) || withinRepeatedErrorWindow(Date.now()))
      throw error;
    return { chunkLoadFailed: true };
  }

  componentDidCatch(error) {
    if (!setStoredValue(RELOAD_ATTEMPTED_AT_KEY, Date.now())) throw error;
    window.location.reload();
  }

  render() {
    return this.state.chunkLoadFailed ? null : this.props.children;
  }
}

export default ChunkErrorBoundary;
